import { z } from 'zod';

export const addBrandSchema = z.object({
  name: z.string().trim().min(1, 'Brand name is required').max(80, 'Brand name is too long'),
  image: z.custom<File>((value) => value instanceof File, {
    message: 'Brand logo is required',
  }),
});

export type AddBrandInput = z.infer<typeof addBrandSchema>;
